import { TokenLogout } from "API/Logout/logout";
import axios from "axios";


const url = process.env.REACT_APP_BACKEND_URL



export const GetFosList = async (page, filter, setData, setLoading, handleAlertOpen) => {
    setLoading(true);
    let params = { page: page }
    if (filter && filter.key && filter.value) {
        params[filter.key] = filter.value;
    }
    try {
        await axios.get(`${url}/map/get_fos_user_details`, {
            headers: {
                "Authorization": `Bearer ${sessionStorage.getItem("token")}`
            },
            params: params
        }
        ).then((response) => {
            setLoading(false);
            setData(response.data);

        })

    }
    catch (error) {
        setLoading(false);
        console.error("Error fetching FOS list:", error);
        handleAlertOpen(error.response && error.response.data.error ? error.response.data.error : "Unable to fetch fos data", "error");
        TokenLogout(error);
    }
    finally {
        setLoading(false);
    }
}


export const GetCspForFos = async (page,fosId, setIsLoading, setData, handleAlertOpen) => {
    setIsLoading(true);
    try {
        await axios.get(`${url}/map/get_fos_mapped_agents`, {
            headers: {
                "Authorization": `Bearer ${sessionStorage.getItem("token")}`
            },
            params: {
                fos_id: fosId,
                page: page,
                limit:10
            }
        }).then((response) => {
            setIsLoading(false);
            setData(response.data);
        })

    }
    catch (error) {
        setIsLoading(false);
        console.error("Error fetching CSP for FOS:", error);
        handleAlertOpen(error.response && error.response.data.error ? error.response.data.error : "Unable to fetch csp data", "error");
        TokenLogout(error)
    }
    finally {
        setIsLoading(false);
    }
}

export const DeactivateFos = async (fosId,setIsLoading,handleAlertOpen,handleGet,handleClose)=>{
    setIsLoading(true);
    try{
        await axios.post(`${url}/auth/deactivate_user_role`, { user_id: fosId,user_type:"fos" }, {
            headers: {
                "Authorization": `Bearer ${sessionStorage.getItem("token")}`
            }
        }).then((response) => {
            setIsLoading(false);
            handleAlertOpen(response.data.message, "success");
            setTimeout(()=>{
                handleClose()
                handleGet();
            },2000)
            
        })
    }
    catch (error){
        setIsLoading(false);
        console.error("Error deactivating FOS:", error);
        handleAlertOpen(error.response && error.response.data.error ? error.response.data.error : "Unable to deactivate FOS", "error");
        TokenLogout(error);
    }
    finally {
        setIsLoading(false);
    }
}


